export const WORKSHEETS_HEAD_TITLE = 'Worksheets and Lesson Plans';
export const WORKSHEETS_PAGE_TITLE = 'Worksheets and Lesson Plans';

const WORKSHEETS_HEAD_DESCRIPTION_TEMPLATE =
    'Critical thinking worksheets and lesson plans for {audience}. Teach your kids about logical fallacies, data analysis, symbolic logic, and more.';

const has_selection = (selected) => selected && selected.path !== '';

export function get_worksheets_head_title(selected) {
    return has_selection(selected)
        ? `${WORKSHEETS_HEAD_TITLE} ${selected.title.toLowerCase()}: Critikid `
        : `${WORKSHEETS_HEAD_TITLE}: Critikid`;
}

export function get_worksheets_head_description(selected) {
    const audience = has_selection(selected)
        ? selected.title.toLowerCase()
        : 'grades 2 to 12';

    return WORKSHEETS_HEAD_DESCRIPTION_TEMPLATE.replace('{audience}', audience);
}

export const worksheets_nav_items = [
    {
        path: '',
        title: 'For All Ages',
        header_suffix: '',
        min_age: null,
        max_age: null
    },
    {
        path: 'for-7-9-years-old',
        title: 'For Ages 7–9',
        header_suffix: 'for Ages 7–9',
        min_age: 7,
        max_age: 9
    },
    {
        path: 'for-10-12-years-old',
        title: 'For Ages 10–12',
        header_suffix: 'for Ages 10–12',
        min_age: 10,
        max_age: 12
    },
    {
        path: 'for-13-and-up',
        title: 'For Ages 13+',
        header_suffix: 'for Ages 13+',
        min_age: 13,
        max_age: 18
    }
];
